export async function fetchIceServers(): Promise<RTCIceServer[]> {
  const res = await fetch('/api/turn-credentials');
  if (!res.ok) throw new Error(`turn-credentials ${res.status}`);
  const body = await res.json() as { iceServers: RTCIceServer[] };
  return body.iceServers;
}
